import { render, staticRenderFns } from "./telegramList.vue?vue&type=template&id=6f8370e1&scoped=true"
import script from "./telegramList.vue?vue&type=script&lang=js"
export * from "./telegramList.vue?vue&type=script&lang=js"
import style0 from "./telegramList.vue?vue&type=style&index=0&id=6f8370e1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f8370e1",
  null
  
)

export default component.exports